const MAX_MOBILE_SCREEN_WIDTH = 1000;
export const selectScreen = state => state.screen;

export const selectIsMobile = (state) => selectScreen(state) <= MAX_MOBILE_SCREEN_WIDTH;
export const selectDefTableSize = (state) => selectIsMobile(state) ? 5: 10;
